import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { queryNotice } from "utils/api";
import { Pagination } from "@jdcfe/legao";
import useStores from "stores";

import style from "./index.module.scss";

const App = () => {
  const { loginStore } = useStores();
  const [noticeList, setNoticeList] = useState([]);
  const [noticePage, setNoticePage] = useState(1);
  const [noticeTotal, setNoticeTotal] = useState(1);
  const [noticePageTotal, setPageTotal] = useState(1);
  const [noticePageSize, setNoticePageSize] = useState(20);

  const history = useHistory();

  const goNoticeDetail = (noticeId) => {
    history.push(`/notice/${noticeId}`);
  };

  const goPage = (index, size) => {
    setNoticePage(index === 0 ? 1 : index);
    setNoticePageSize(size);
    getData(index, size);
  };

  const getData = (index, size) => {
    queryNotice({
      pageIndex: index,
      pageSize: size,
    }).then((res) => {
      if (res.data.success) {
        setNoticeList(res.data.result.items);
        setNoticePage(res.data.result.pageIndex);
        setNoticeTotal(res.data.result.pageItemTotal);
        setPageTotal(res.data.result.pageTotal);
        setNoticePageSize(res.data.result.pageSize);
      }
    });
  };
  useEffect(() => {
    getData(noticePage, noticePageSize);
  }, []); //eslint-disable-line
  return (
    <div className={`${style.noticeListWrapper}`}>
      <div className={`${style.tipHeaderContainer}`}>
        <div className={`${style.content}`}>
          <div className={`${style.left}`}>
            <i></i>
            <span>消息公告</span>
          </div>
          <div className={`${style.right}`}>
            <span>消息公告</span>
            <span className={`${style.line}`}>/</span>
            <span className={`${style.gray}`}>系统公告</span>
          </div>
        </div>
      </div>
      <div className={`${style.noticeList}`}>
        <div className={`${style.content}`}>
          <div className={`${style.noticeNavContainer}`}>
            <div className={`${style.title}`}>公告类型</div>
            <div className={`${style.navList}`}>
              <div className={`${style.item} ${style.cur}`}>
                <Link
                  to="/notice"
                  clstag="pageclick|keycount|VopOpenIndex_1602911919488|8"
                >
                  系统公告
                </Link>
              </div>
              {loginStore.isLogin ? (
                <div className={`${style.item}`}>
                  <Link to="/message">消息通知</Link>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className={`${style.noticeListContainer}`}>
            <div className={`${style.header}`}>
              <div className={`${style.left}`}>系统公告</div>
              <div className={`${style.right}`}>时间</div>
            </div>
            <div className={`${style.list}`}>
              {noticeList.length
                ? noticeList.map((item, index) => (
                    <div
                      className={`${style.listItem}`}
                      key={index}
                      
                    >
                      <div 
                          className={`${style.desc}`}
                          onClick={() => {
                            goNoticeDetail(item.noticeId);
                          }}
                        >
                        <span>
                          {item.noticeTitle}
                        </span>
                      </div>
                      <div className={`${style.time}`}>{item.updateTime}</div>
                    </div>
                  ))
                : ""}
            </div>
            <div className={`${style.page}`}>
              <Pagination
                className={"pagination-demo"}
                prefixCls={"lg"}
                type={"basic"}
                defaultCurrent={noticePage}
                total={noticeTotal}
                pageSize={noticePageSize}
                viewSize={noticePageTotal}
                hasChangeSize={true}
                hasJump={true}
                hasTotal={true}
                onChange={(index, size) => {
                  goPage(index, size);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
